import React from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../../../../components/Input';
import TextArea from '../../../../../components/TextArea';
import Switch from '../../../../../components/Switch';
import { VALIDATION_FIELD_MAPPING } from '../../../../../utils/appConstant';
import { Validation } from '../../../../../interfaces/common';
import { AddEdit as AddEditInterface } from '../../../../../interfaces/productDivision.interface';

interface DivisionDetailsTabProps {
  edit: boolean;
  view?: boolean;
  formData: AddEditInterface;
  validation: Validation;
  onKeyDown: (e: any, name?: string) => void;
  onInputBlur: (e: any, name: string) => void;
  onInputChange: (e: any, name: string) => void;
}

const DivisionDetailsTab: React.FC<DivisionDetailsTabProps> = ({
  edit,
  view,
  formData,
  validation,
  onKeyDown,
  onInputBlur,
  onInputChange,
}) => {
  const { t } = useTranslation();

  return (
    <form className="card-body" autoComplete="off">
      <div className="row g-6">
        <h6 className="mb-0">1. {t('productDivisions.addEdit.pageTexts.form.sections.primaryDetails')}</h6>

        <div className="col-md-6">
          <div className="form-floating form-floating-outline">
            <Input
              type="text"
              required
              id={VALIDATION_FIELD_MAPPING.name}
              name={VALIDATION_FIELD_MAPPING.name}
              disabled={view}
              error={!!validation.fields.find((field) => field.field === VALIDATION_FIELD_MAPPING.name)}
              errorMessage={
                validation.fields.find((field) => field.field === VALIDATION_FIELD_MAPPING.name)
                  ?.message ?? ''
              }
              label={t('productDivisions.addEdit.pageTexts.form.name.label')}
              placeholder={t('productDivisions.addEdit.pageTexts.form.name.placeholder')}
              value={formData.name}
              onKeyDown={onKeyDown}
              onBlur={(e) => onInputBlur(e, VALIDATION_FIELD_MAPPING.name)}
              onChange={(e) => onInputChange(e, VALIDATION_FIELD_MAPPING.name)}
            />
          </div>
        </div>

        <h6 className="mb-0 mt-4">2. {t('productDivisions.addEdit.pageTexts.form.sections.otherInformation')}</h6>

        <div className="col-md-10">
          <div className="form-floating form-floating-outline">
            <TextArea
              required
              className="form-control-lg h-100"
              id={VALIDATION_FIELD_MAPPING.description}
              name={VALIDATION_FIELD_MAPPING.description}
              disabled={view}
              error={
                !!validation.fields.find(
                  (field) => field.field === VALIDATION_FIELD_MAPPING.description
                )
              }
              errorMessage={
                validation.fields.find(
                  (field) => field.field === VALIDATION_FIELD_MAPPING.description
                )?.message ?? ''
              }
              label={t('productDivisions.addEdit.pageTexts.form.description.label')}
              placeholder={t('productDivisions.addEdit.pageTexts.form.description.placeholder')}
              value={formData.description}
              rows={5}
              onKeyDown={onKeyDown}
              onBlur={(e) => onInputBlur(e, VALIDATION_FIELD_MAPPING.description)}
              onChange={(e) => onInputChange(e, VALIDATION_FIELD_MAPPING.description)}
            />
          </div>
        </div>

        <div className="col-md-2">
          <Switch
            label={t('productDivisions.addEdit.pageTexts.form.status.label')}
            name={VALIDATION_FIELD_MAPPING.status}
            checked={formData.status === 'true'}
            disabled={view}
            onChange={(e: any, name: string) => {
              const value = e.target.checked ? 'true' : 'false';
              const fakeEvent = { target: { value } };
              onInputChange(fakeEvent, name);
            }}
          />
        </div>
      </div>
    </form>
  );
};

export default DivisionDetailsTab;
